<template>
  <div id="app">
   <audio class="audio" src="" controls autoplay="autoplay" :hidden="true"></audio>
  
    <router-view/>
    
  </div>
</template>

<script>
export default {
  name: 'App',

  
}

</script>

<style>

::-webkit-scrollbar-track
{
  background: rgba(0,0,0,.1);
  border-radius: 0;
}

::-webkit-scrollbar
{
  -webkit-appearance: none;
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-thumb
{
    cursor: pointer;
    border-radius: 5px;
    background: rgba(0,0,0,.25);
    transition: color .2s ease;
}
a,a:hover{
  text-decoration: none !important;
}
ul,li{
  padding:0;
  margin:0;
  list-style:none;
}
body{
  background-color:#e4e5e6!important;
}
body,.el-menu-item,.el-table,.el-form-item__label,.el-form-item__content,.el-button{
  font-size:13px;  font-family: Helvetica Neue,Helvetica,Arial,sans-serif
}

.bg-white{
  background-color:transparent !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue